//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../GeometricUtilities/GeometricUtilities.ControlPoleManagerData.js";
import "../no/SelectFace.js";
import "../GeometricUtilities/GeometricUtilities.Continuity.js";
import "../no/GeometricUtilities.js";
import "../no/SelectObject.js";
let d=[[[0,"ApplyConstraintsToAll",1,0],[0,"ModificationPercentage",1,0],[0,"MoveOnlySelectedPoles",1,0],[0,"MovementVector",1,"Direction",0],[0,"NumberPolesSelected",1,0],[1,"Poles",0,"GeometricUtilities.ControlPoleManagerData",0],[0,"SmoothingFactor",1,0],[1,"TargetFace",0,"SelectFace",0],[1,"UMaxConstraint",0,"GeometricUtilities.Continuity",0],[1,"UMinConstraint",0,"GeometricUtilities.Continuity",0],[0,"UseSpecificDirection",1,0],[1,"VMaxConstraint",0,"GeometricUtilities.Continuity",0],[1,"VMinConstraint",0,"GeometricUtilities.Continuity",0]],[[["array_length","selected_poles_index"],"GetSelectedPolesIndex",{},0,0],[["selected_poles_index"],"SetSelectedPolesIndex",{},1,0],[[],"GetCreateNewCopy",{R_:{createNewCopy:''}},0,0],[["createNewCopy"],"SetCreateNewCopy",{},1,0],[["face"],"RemoveFeatureParameters",{},1,0]],[]];
SPLM.Features.PoleSmoothingBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.PoleSmoothingBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;